module.exports = __webpack_public_path__ + "static/media/FB_IMG_1614884097410.a4a4ca4a.jpg";